import { render, staticRenderFns } from "./Frage_6.vue?vue&type=template&id=3a8dd40e&"
import script from "./Frage_6.vue?vue&type=script&lang=js&"
export * from "./Frage_6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports